module.exports = __webpack_public_path__ + "static/media/unx_major_re-air.b94ee548.png";